var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Page',{attrs:{"pageIndex":_vm.$store.state.filteredPageLabels.indexOf(_vm.$store.state.currentPage) + 1}})
}
var staticRenderFns = []

export { render, staticRenderFns }